export interface StockItemAlreadyReceived {
  stockNo: string;
  batchNo: string;
  externalNo: string;
  quantity: number;
  warehouse: string;
  location: string;
  dateCreated: Date;
  supplierDeliveryNoteNo: string;
}
